import type { Component, Entity2D } from '../../odie';

import type { FullIceBlockProps } from '../defs/block';
import { FullIceBlockView } from '../views/blocks/FullIceBlockView';

// types
//-----------------------------------------------------------------------------
export type FullIceBlockComponentOptions = {
  props: FullIceBlockProps;
};

/*
    full ice block component
*/
export class FullIceBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockFullIce';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: FullIceBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: FullIceBlockComponentOptions): void {
    // create full ice block view
    this.view = new FullIceBlockView(options.props);
  }
}
